module.exports = __webpack_public_path__ + "img/108014.637e264b.png";